// extracted by mini-css-extract-plugin
export default {"container":"Blog_container__+J801","Box":"Blog_Box__Ea7RL","miniBox":"Blog_miniBox__v7rDW"};